<div class="row mt-2 pt-3 pb-4">
    <div class="col-9 text-left">
        <h5 class="inner-heading">Beneficiary Information</h5>
    </div>
    <div class="col-3 text-right">
        <mat-button-toggle-group [value]="selectedState" (change)="onChange($event)">
            <mat-button-toggle value="simple">Simple Profile</mat-button-toggle>
            <mat-button-toggle value="complete">Complete Profile</mat-button-toggle>
        </mat-button-toggle-group>
    </div>
</div>
<div class="profile-component-container">
    <div *ngIf="selectedState == 'simple'">
        <!-- <app-simple-profile></app-simple-profile> -->
    </div>
</div>